const settingMap = {};
const listingColumnTypeMap = {};
let ETLData = {};
let accountUUID = '';

function getValueFromJson(jsonData, m1Key, settingName, defaultValue = '') {
    const m1KeyValue = jsonData[m1Key];
    if (!m1KeyValue) return defaultValue;
  
    const uuidValue = settingMap[settingName]?.uuid;
    const typeValue = settingMap[settingName]?.type;
    if (!uuidValue || !typeValue) return defaultValue;
  
    return m1KeyValue[uuidValue]?.[typeValue] || defaultValue;
}


export const ETL = (jsonData) => {
    ETLData = Object.assign({}, jsonData);
    ETLData.configurations_group = {};
    ETLData.settings = {};
    ETLData['icons.'] = {
        "ada": "ada",
        "atm": "atm",
        "coffee": "coffee",
        "dollarSign": "dollarSign",
        "elevator": "elevator",
        "escalator": "escalator",
        "food": "food",
        "gift": "gift",
        "info": "info",
        "mens": "mens",
        "north": "north",
        "parking": "parking",
        "restrooms": "restrooms",
        "stairs": "stairs",
        "womens": "womens",
        "you_are_here_0": "you_are_here_0",
        "you_are_here_45": "you_are_here_45",
        "you_are_here_90": "you_are_here_90",
        "you_are_here_135": "you_are_here_135",
        "you_are_here_180": "you_are_here_180",
        "you_are_here_225": "you_are_here_225",
        "you_are_here_270": "you_are_here_270",
        "you_are_here_315": "you_are_here_315"
    };

    Object.entries(jsonData).forEach(([ m1Key, m1Val, ]) => {
        if (m1Key.startsWith('setting.')) {
            let type = '';
            Object.keys(m1Val).forEach((m2Key) => {
                if (m2Key.startsWith('setting_type')) {
                    type = jsonData[m2Key].type;
                }
            });

            settingMap[m1Val.name] = {
                uuid: m1Key,
                type
            };
        }

        if (m1Key.startsWith('listing_column_type.')) {
            listingColumnTypeMap[m1Key] = m1Val.type;
        }

        if (m1Key.startsWith('account.')) {
            accountUUID = m1Key;
        }
    });

    // console.log('Setting Map', settingMap);
    // console.log('Listing Column Type Map', listingColumnTypeMap);

    function setEtlDataFromArray (m1Key, m1KeyName, settingsArr, callback = null) {
        if (m1Key.startsWith(m1KeyName)) {
            settingsArr.forEach((setting) => {
                let defaultValue = null;
                if (m1Key.startsWith('wf_config.') && setting === 'map_rotation') {
                    defaultValue = 0;
                }
                ETLData[m1Key][setting] = getValueFromJson(jsonData, m1Key, setting, defaultValue);
            }); 
            
            callback && callback();
        }
    }

    function setEtlDataViaMatch (m1Key, m1Val, m1KeyName, m2KeyNameArr, deleteDisplayName, callback = null) {
        if (m1Key.startsWith(m1KeyName)) {
            Object.entries(m1Val).forEach(([ m2Key, m2Val, ]) => {
                if (m2KeyNameArr && Array.isArray(m2KeyNameArr) && m2KeyNameArr.length > 0) {
                    m2KeyNameArr.forEach((keyName) => {
                        if (m2Key.startsWith(keyName)) {
                            callback && callback(m2Key);
                        }
                    });
                }
                
            });
            
            if (deleteDisplayName) {
                delete ETLData[m1Key].display_name;
            }
        }
    }

    Object.entries(jsonData).forEach(([ m1Key, m1Val, ]) => {
        if (m1Key.startsWith('account.')) {
            const accountDefaults = {
                'wf_location_marker_color': 'red',
                'wf_location_marker_size': 100,
                'wf_location_marker_use': false,
                'wf_map_delay_in': 1.5,
                'wf_map_delay_out': 3,
                'wf_move_point_modifier': 10,
                'wf_path_color': 'red',
                'wf_path_endmarker_size': 15,
                'wf_path_endmarker': 'triangle',
                'wf_path_speed': 1,
                'wf_path_width': 5,
                'wf_variable_colors': '',
            };

            ETLData[m1Key] = {
                accountDefaults,
                ...m1Val,
            }

            const requiredSettings = [
                'wf_location_marker_color',
                'wf_location_marker_size',
                'wf_location_marker_use',
                'wf_map_delay_in',
                'wf_map_delay_out',
                'wf_move_point_modifier',
                'wf_path_color',
                'wf_path_endmarker_size',
                'wf_path_endmarker',
                'wf_path_speed',
                'wf_path_width',
            ];
            for (const setting of requiredSettings) {
                if (m1Val[setting] === 0 || m1Val[setting] === '' || m1Val[setting] === null || m1Val[setting] === undefined) {
                    ETLData[m1Key][setting] = accountDefaults[setting];
                }
            }
        }

        if (m1Key.startsWith('wf_map_graphic.')) {
            const wfMapGraphicSettings = [
                'building',
                'campus_map',
                'canvas_height',
                'canvas_width',
                'floor',
                'map_scale',
                'primary_map',
                'source',
            ];

            wfMapGraphicSettings.forEach((wfMapGraphicSetting) => {
                let tempData = ''
                
                if (wfMapGraphicSetting === 'map_scale') {
                    tempData = 1.0
                }

                if (wfMapGraphicSetting === 'campus_map' || wfMapGraphicSetting === 'primary_map') {
                    tempData = false
                }

                ETLData[m1Key][wfMapGraphicSetting] = getValueFromJson(jsonData, m1Key, wfMapGraphicSetting, tempData);
            });

            Object.entries(m1Val).forEach(([ m2Key, m2Val, ]) => {
                const settingsObj = {
                    'wf_config.': 'configuration',
                    'wf_point_group.': 'map_points',
                    'wf_map_location_group.': 'map_locations',
                    'wf_line_group.': 'lines',
                    'wf_map_ap_group.': 'map_ap_group',
                    'wf_map_vt_group.': 'map_vt_group'
                };

                Object.entries(settingsObj).forEach(([ settingKey, settingValue, ]) => {
                    if (m2Key.startsWith(settingKey)) {
                        ETLData[m1Key][settingValue] = m2Key;
                    }
                });
            });
        }

        setEtlDataViaMatch(m1Key, m1Val, 'wf_graphic_ref.', ['wf_graphic_text.', 'wf_graphic_icon.', 'wf_graphic_image.'], false, (m2Key) => {
            ETLData[m1Key].graphic = m2Key;
        });

        setEtlDataViaMatch(m1Key, m1Val, 'wf_graphic_ref.', ['wf_config.'], false, (m2Key) => {
            ETLData[m1Key].configuration = m2Key;
        });

        setEtlDataFromArray(m1Key, 'wf_graphic_text.', [
            'align_vert',
            'align_horiz',
            'background_color',
            'border_color',
            'wf_border_width',
            'color',
            'custom_class',
            'font',
            'font_weight',
            'height',
            'label',
            'padding',
            'size',
            'type',
            'value',
            'width',
            'line_height',
            'wf_text_align',
            'border_radius',
        ]);

        setEtlDataFromArray(m1Key, 'wf_graphic_image.', [
            'custom_class',
            'label',
            'type',
            'value',
            'width',
        ]);

        setEtlDataFromArray(m1Key, 'wf_graphic_icon.', [
            'align_vert',
            'align_horiz',
            'background_color',
            'wf_border_width',
            'border_color',
            'border_radius',
            'padding',
            'height',
            'width',
            'value',
            'family',
            'icon_color',
            'icon_color_2',
            'icon_size',
            'filter',
            'label',
            'type',
        ]);

        setEtlDataFromArray(m1Key, 'wf_graphic_ref.', [
            'rotate',
            'scale',
            'x',
            'y',
            'z_index',
            'map_rotation',
        ]);

        setEtlDataViaMatch(m1Key, m1Val, 'system.', ['wf_point.'], false, (m2Key) => {
            ETLData[m1Key].assigned = m2Key;
        });

        setEtlDataViaMatch(m1Key, m1Val, 'system.', ['wf_config.'], false, (m2Key) => {
            ETLData[m1Key].configuration = m2Key;
        });

        setEtlDataFromArray(m1Key, 'wf_config.', [
            'background_color',
            'background_top',
            'background_left',
            'background_size',
            'canvas_height',
            'canvas_width',
            'canvas_position_left',
            'canvas_position_top',
            'map_rotation',
            'map_container_height',
            'map_container_width',
        ], () => {
            ETLData.configurations_group[m1Key] = {};
        });

        setEtlDataViaMatch(m1Key, m1Val, 'wf_line_group.', ['wf_line.'], true, (m2Key) => {
            Object.entries(ETLData[m2Key]).forEach(([ m3Key, m3Val, ]) => {
                if (m3Key.startsWith('wf_point.')) {
                    ETLData[m1Key][m2Key][m3Key] = {};
                }
            });
        });

        setEtlDataViaMatch(m1Key, m1Val, 'wf_point_group.', ['wf_point.'], true, (m2Key) => {
            const coordinates = [];
            coordinates.push(ETLData[m2Key].x);
            coordinates.push(ETLData[m2Key].y);
            ETLData[m1Key][m2Key] = coordinates;
        });

        setEtlDataViaMatch(m1Key, m1Val, 'wf_point.', ['listing_column_type.'], true, (m2Key) => {
            ETLData[m1Key][m2Key].value = ETLData[m1Key][m2Key][listingColumnTypeMap[m2Key]];
        });


        if (m1Key.startsWith('wf_map_location_group.')) {
            delete ETLData[m1Key].display_name;
        }
    });

    return ETLData;
};


export const ETLMerge = (jsonData, data) => {
    return {
        ...data,
        ...ETL(jsonData)
    };
};


export const decodeChanges = (pendingUpdates) => {
    const keys = [];
    const vals = [];
    const numericTypes = [ 'int', 'float', ];

    function pushKeyVals(relationKey, relationVal, columnKey, columnVal) {
        if (relationKey && columnKey && relationVal !== undefined && columnVal !== undefined) {
            keys.push(relationKey, columnKey);
            vals.push(relationVal, columnVal);
        } else if (relationKey && relationVal !== undefined) {
            keys.push(relationKey);
            vals.push(relationVal);
        }
    }

    function decodeEtlData (m1Key, m1Val, m1KeyName, m2KeyNameArr, settingMapM2Key, innerCallback = null, outerCallback = null) {
        if (m1Key.startsWith(m1KeyName)) {

            Object.entries(m1Val).forEach(([ m2Key, m2Val, ]) => {
                if (settingMapM2Key && settingMap[m2Key]) {
                    const relationKey = `${m1Key}.${settingMap[m2Key].uuid}`;
                    const relationVal = true;
                    const columnKey = `${m1Key}.${settingMap[m2Key].uuid}.${settingMap[m2Key].type}`;
                    const columnVal = numericTypes.includes(settingMap[m2Key].type) ? Number(m2Val) : m2Val;
                    pushKeyVals(relationKey, relationVal, columnKey, columnVal);
                }

                if (m2KeyNameArr && Array.isArray(m2KeyNameArr) && m2KeyNameArr.length > 0) {
                    m2KeyNameArr.forEach((keyName) => {
                        if (m2Key.startsWith(keyName)) {
                            let relKey = m2Key;
                            let relVal = true;
                            
                            if (['display_name', 'instruction_text', 'map_name', 'point_restriction', 'label_font_size', 'label_wrap_width', 'label_zoom_level'].includes(keyName)) {
                                relVal = m2Val;
                            }
                            
                            if (m1Key.startsWith('wf_graphic_ref.')) {
                                console.log('wf_graphic_ref.', m1Key, m1Val);
                                relKey = m2Val;
                            }

                            const relationKey = `${m1Key}.${relKey}`;
                            const relationVal = relVal;
                            pushKeyVals(relationKey, relationVal);

                            innerCallback && innerCallback(m2Key, m2Val);
                        }
                    });
                }

                outerCallback && outerCallback(m2Key, m2Val);
            });
            
        }
    }

    Object.entries(pendingUpdates).forEach(([ m1Key, m1Val, ]) => {

        if (m1Key === 'settings') {
            Object.entries(m1Val).forEach(([ m2Key, m2Val, ]) => {
                const settingKey  = settingMap[m2Key].uuid;
                const settingType  = settingMap[m2Key].type;
                const relationKey = `${accountUUID}.${settingKey}`;
                const relationVal = true;
                const columnKey = `${accountUUID}.${settingKey}.${settingType}`;
                const columnVal = numericTypes.includes(settingMap[m2Key].type) ? Number(m2Val.value) : m2Val.value;
                pushKeyVals(relationKey, relationVal, columnKey, columnVal);
            });
        }

        decodeEtlData(m1Key, m1Val, 'account.', ['wf_graphic_group.', 'wf_config.']);

        decodeEtlData(m1Key, m1Val, 'system_group.', ['wf_map_graphic.'], false, null, (m2Key, m2Val) => {
            if (settingMap[m2Key]) {
                const relationKey = `${m1Key}.${settingMap[m2Key].uuid}`;
                const relationVal = true;
                const columnKey = `${m1Key}.${settingMap[m2Key].uuid}.${settingMap[m2Key].type}`;
                const columnVal = numericTypes.includes(settingMap[m2Key].type) ? Number(m2Val.value) : m2Val.value;
                pushKeyVals(relationKey, relationVal, columnKey, columnVal);
            }
        });

        decodeEtlData(m1Key, m1Val, 'system.', ['wf_location_marker_color.', 'wf_location_marker_size.', 'wf_location_marker_use.'], false, null, (m2Key, m2Val) => {
            if (settingMap[m2Key]) {
                const relationKey = `${m1Key}.${settingMap[m2Key].uuid}`;
                const relationVal = true;
                const columnKey = `${m1Key}.${settingMap[m2Key].uuid}.${settingMap[m2Key].type}`;
                const columnVal = numericTypes.includes(settingMap[m2Key].type) ? Number(m2Val.value) : m2Val.value;
                pushKeyVals(relationKey, relationVal, columnKey, columnVal);
            }
        });

        decodeEtlData(m1Key, m1Val, 'system.', ['wf_graphic_group.']);

        decodeEtlData(m1Key, m1Val, 'system.', [], false, null, (m2Key, m2Val) => {
            Object.entries(m1Val).forEach(([ m2Key, m2Val, ]) => {
                if (m2Key === 'assigned' || m2Key === 'configuration') {
                    if (m2Val === 'none') {
                        if (ETLData[m1Key][m2Key] !== undefined) {
                            const oldRelation = `${m1Key}.${ETLData[m1Key][m2Key]}`;
                            const oldRelationVal = false;
                            pushKeyVals(oldRelation, oldRelationVal);
                        }
                    } else {
                        if (ETLData[m1Key][m2Key] !== undefined) {
                            const oldRelation = `${m1Key}.${ETLData[m1Key][m2Key]}`;
                            const oldRelationVal = false;
                            pushKeyVals(oldRelation, oldRelationVal);
                        }

                        const newRelationKey = `${m1Key}.${m2Val}`;
                        const newRelationVal = true;
                        pushKeyVals(newRelationKey, newRelationVal);
                    }
                }
            });
        });

        decodeEtlData(m1Key, m1Val, 'wf_map_location_group.', ['wf_point.']);

        decodeEtlData(m1Key, m1Val, 'wf_map_ap_group.', ['wf_point.', 'display_name', 'wf_map_ap_group.', 'instruction_text']);

        decodeEtlData(m1Key, m1Val, 'wf_map_vt_group.', ['wf_point.', 'display_name', 'wf_map_vt_group.', 'instruction_text']);

        decodeEtlData(m1Key, m1Val, 'wf_map_graphic.', ['display_name', 'wf_graphic_group.', 'map_name', 'label_font_size', 'label_wrap_width', 'label_zoom_level'], true, null, (m2Key, m2Val) => {
            if (m2Key === 'lines' ||
                m2Key === 'map_locations' ||
                m2Key === 'map_points' ||
                m2Key === 'map_ap_group' ||
                m2Key === 'map_vt_group') {
                const relationKey = `${m1Key}.${m2Val}`;
                const relationVal = true;
                pushKeyVals(relationKey, relationVal);
            }

            if (m2Key === 'configuration') {
                if (ETLData?.[m1Key]?.[m2Key] !== undefined) {
                    const oldRelation = `${m1Key}.${ETLData[m1Key][m2Key]}`;
                    const oldRelationVal = false;
                    pushKeyVals(oldRelation, oldRelationVal);
                }
                const relationKey = `${m1Key}.${m2Val}`;
                const relationVal = true;
                pushKeyVals(relationKey, relationVal);
            }
        });

        decodeEtlData(m1Key, m1Val, 'wf_graphic_text.', null, true);

        decodeEtlData(m1Key, m1Val, 'wf_graphic_image.', null, true);

        decodeEtlData(m1Key, m1Val, 'wf_graphic_icon.', null, true);

        decodeEtlData(m1Key, m1Val, 'wf_graphic_ref.', ['graphic', 'configuration'], true);

        decodeEtlData(m1Key, m1Val, 'wf_graphic_group.', ['wf_graphic_ref.', 'wf_graphic_icon.', 'wf_graphic_image.', 'wf_graphic_text.']);

        decodeEtlData(m1Key, m1Val, 'wf_config.', ['display_name'], true);

        decodeEtlData(m1Key, m1Val, 'wf_point.', ['point_restriction'], true);

        decodeEtlData(m1Key, m1Val, 'wf_point_group.', ['wf_point.', 'point_restriction'], false, (m2Key, m2Val) => {
            if (m2Key.startsWith('wf_point.')) {
                const relationKeyX = `${m2Key}.x`;
                const relationValX = m2Val[0];
                pushKeyVals(relationKeyX, relationValX);
                
                const relationKeyY = `${m2Key}.y`;
                const relationValY = m2Val[1];
                pushKeyVals(relationKeyY, relationValY);
            }
        }, null);

        if (m1Key.startsWith('wf_point.')) {
            if (Array.isArray(m1Val)) {
                const relationKeyX = `${m1Key}.x`;
                const relationValX = m1Val[0];
                pushKeyVals(relationKeyX, relationValX);
    
                const relationKeyY = `${m1Key}.y`;
                const relationValY = m1Val[1];
                pushKeyVals(relationKeyY, relationValY);
            } else {
                Object.entries(m1Val).forEach(([ m2Key, m2Val, ]) => {
                    if (m2Key.startsWith('listing_column_type.')) {
                        if (ETLData[m1Key]?.[m2Key] !== undefined) {
                            const oldRelation = `${m1Key}.${ETLData[m1Key][m2Key]}`;
                            const oldRelationVal = false;
                            pushKeyVals(oldRelation, oldRelationVal);
                        }

                        const relationKey = `${m1Key}.${m2Key}`;
                        const relationVal = true;
                        const columnKey = `${m1Key}.${m2Key}.${listingColumnTypeMap[m2Key]}`;
                        const columnVal = m2Val.value;
                        pushKeyVals(relationKey, relationVal, columnKey, columnVal);
                    } else if (m2Key === 'location_array') {
                        const relationKey = `${m1Key}.location_array`;
                        const relationVal = m1Val.location_array;
                        pushKeyVals(relationKey, relationVal);
                    } else if (m2Key === 'display_label') {
                        const relationKey = `${m1Key}.display_label`;
                        const relationVal = m1Val.display_label;
                        pushKeyVals(relationKey, relationVal);
                    } else {
                        const relationKeyX = `${m1Key}.x`;
                        const relationValX = m1Val.x;
                        pushKeyVals(relationKeyX, relationValX);
            
                        const relationKeyY = `${m1Key}.y`;
                        const relationValY = m1Val.y;
                        pushKeyVals(relationKeyY, relationValY);
                    }
                });
            }
        }

        decodeEtlData(m1Key, m1Val, 'wf_line_group.', ['wf_line.'], false, (m2Key, m2Val) => {
            Object.entries(m2Val).forEach(([ m3Key, m3Val, ]) => {
                if (m3Key.startsWith('wf_point.')) {
                    const relationKey = `${m2Key}.${m3Key}`;
                    const relationVal = true;
                    pushKeyVals(relationKey, relationVal);
                    
                }
            });

        }, null);

        decodeEtlData(m1Key, m1Val, 'wf_line.', ['wf_point.']);
    });

    return {
        keys,
        vals,
    };
};

export const decodeDeletes = (pendingDeletes, previousDeletes) => {
    const keys = previousDeletes?.keys || [];
    const vals = previousDeletes?.vals || [];

    function decodeDeleteEtlDataNew (m1Key, m1Val, deleteObj) {
        Object.entries(deleteObj).forEach(([ m1KeyName, m2KeyNameArr, ]) => {

            if (m1Key.startsWith(m1KeyName)) {

                Object.entries(m1Val).forEach(([ m2Key, m2Val, ]) => {
                    if (m2KeyNameArr && Array.isArray(m2KeyNameArr) && m2KeyNameArr.length > 0) {
                        m2KeyNameArr.forEach((keyName) => {
                            if (m2Key.startsWith(keyName)) {
                                const relationKey = `${m1Key}.${m2Key}`;
                                const relationVal = false;
            
                                keys.push(relationKey);
                                vals.push(relationVal);
                            }
                        });
                    }
                });
                
            }
        });
    }

    Object.entries(pendingDeletes).forEach(([ m1Key, m1Val, ]) => {
        decodeDeleteEtlDataNew(m1Key, m1Val, {
            'account.': ['wf_config.'],
            'system_group.': ['wf_map_graphic.'],
            'wf_graphic_group.': ['wf_graphic_ref.'],
            'wf_map_graphic.': ['wf_config.', 'wf_point_group.', 'wf_line_group.', 'wf_map_ap_group.', 'wf_map_vt_group.'],
            'wf_line_group.': ['wf_line.'],
            'wf_point_group.': ['wf_point.'],
            'wf_map_location_group.': ['wf_point.'],
            'wf_map_ap_group.': ['wf_point.', 'wf_map_ap_group.'],
            'wf_map_vt_group.': ['wf_point.', 'wf_map_vt_group.'],
            'system.': ['wf_point', 'wf_graphic_group.', 'wf_config.'],
            'wf_line.': ['wf_point.'],
            'wf_point.': ['listing_column_type.'],
        });
    });

    return {
        keys,
        vals,
    };
};